module.exports = __webpack_public_path__ + "static/2020大中华区新业态经济最佳实践平台-2c3454b1dc77f16ea0562b3a059011a5.png";